import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch } from "@/store";
import { updateToken } from "@/features/auth/authSlice";
import { getServiceHubToken } from "@/features/all-apps/serviceHubApi";

export const useFetchToken = () => {
  const { getAccessTokenSilently } = useAuth0();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);

  if (!process.env.REACT_APP_AUTH0_AUDIENCE)
    throw new Error("Failed to find the REACT_APP_AUTH0_AUDIENCE");

  useEffect(() => {
    getAccessTokenSilently({
      detailedResponse: true,
    }).then((response) => {
      dispatch(updateToken(response.access_token));
      setLoading(false);
      getServiceHubToken().catch(() => {});
    });
  }, [dispatch, getAccessTokenSilently]);

  return { isLoading };
};
